import React, { useState } from 'react';
import { View } from 'react-native';
import DataTable from '@preflighttech/preflight-tables';

import RelayTable from 'app/src/elements/Table/RelayTable';
import { Title, Text } from 'app/src/styles';
import { Link } from 'app/src/utils/routing';

import { CLIENTS } from './queries';

const columns = [
  {
    key: 'name',
    label: 'Name',
  },
  {
    key: 'actions',
    sort: 'prevent',
    content: ({ entry }) => (
      <View style={{ flexDirection: 'row', gap: 12 }}>
        <Link to={`/clients/${entry.id}`}>
          <Text>View/Edit</Text>
        </Link>

        <Link to={`/clients/${entry.id}/events`}>
          <Text>Events</Text>
        </Link>
      </View>
    )
  }
];

const Clients = () => {
  const [refetch, setRefetch] = useState();

  return (
    <View>
      <Title>Clients</Title>

      <Link to="/clients/new">
        <Text>Add Client</Text>
      </Link>

      <RelayTable
        query={CLIENTS}
        queryName="clients"
        columns={columns}
        setRefetch={setRefetch}
      />
    </View>
  );
};

export default Clients;
